<template>
    <register-popup></register-popup>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        mounted() {
        },
        computed: {
        },
        methods: {
        }
    }
</script>
